//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UMUM from "../../library/umum";
import WILAYAH      from "../../library/getWilayah"  ;

export default {
  data() {
    return {
      form : {
            id : '',
            nama : '',
            jabatan : '',
            tpt_lahir : '',
            tgl_lahir : '',
            pendidikan : '',
            agama : '',
            createdAt : '',
            createdBy : '',
            file : null,
            des_kel : '',
        },
        uraian : {
          agama_uraian : '',
          pendidikan_uraian : ''
        },

        fileOld : '',




        list_data : [],
        list_pendidikan : [],
        list_agama : [],
        page_limit : 8,
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,


        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_lihat: false,
        mdl_lihat_file: false,
        btn_add: false,

        UMUM : UMUM,
    };
  },
  methods: {
// URL_CNT_DESA_DATA_PEGAWAI
    

    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_DESA_DATA_PEGAWAI + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value,
              des_kel : this.form.des_kel
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    selectData : function(data){
            this.form.nama = data.nama;
            this.form.jabatan = data.jabatan;
            this.form.tgl_lahir = data.tgl_lahir;
            this.form.tpt_lahir = data.tpt_lahir;
            this.uraian.agama_uraian = data.agama_uraian;
            this.uraian.pendidikan_uraian= data.pendidikan_uraian;
            this.form.file = data.file;
        

    },

    cari_data: function() {
      this.page_first = 1;
      this.getView();
    },
    indexing: function(index) {
      var idx = (this.page_first - 1) * this.page_limit + index;
      return idx;
    },
    changeKategory(data){
      console.log(data)
      this.form.kategori = data
      this.getView()
    },
  },
  mounted() {
    const d = new Date();
    this.form.tahun = d.getFullYear();
    console.log(this.form.tahun)
    this.form.des_kel = this.$store.state.ID_DES_KEL


    this.$store.state.kegiatan.id = this.$route.query.id;
    // this.$store.commit('getOne')
    this.form.tahun = UMUM.getTahun();
    // this.getView();
    WILAYAH.getListDesKelFull();
    this.cari_data();
  }
};
